import { render, staticRenderFns } from "./Bandwidth.vue?vue&type=template&id=5a7e2662&"
import script from "./Bandwidth.vue?vue&type=script&lang=js&"
export * from "./Bandwidth.vue?vue&type=script&lang=js&"
import style0 from "./Bandwidth.vue?vue&type=style&index=0&scopped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports